<template>
  <div class="card">
    <div class="card__top">
      <div class="top-left">
        <div class="id-row">
          <span class="chip">
            <i class="fa-duotone fa-hashtag"></i>
            <span class="chip__label">Loan</span>
            <span class="chip__value">{{ item.loanNumber || "—" }}</span>
          </span>

          <span class="chip">
            <i class="fa-duotone fa-user"></i>
            <span class="chip__label">Borrower</span>
            <span class="chip__value">{{ item.borrowerName || "—" }}</span>
          </span>

          <span class="chip">
            <i class="fa-duotone fa-flag"></i>
            <span class="chip__label">Status</span>
            <span class="chip__value">{{ item.msstatus || "—" }}</span>
          </span>
        </div>

        <div class="address-row">
          <i class="fa-duotone fa-location-dot"></i>
          <span class="address-text">{{ item.fullPropertyAddress || "—" }}</span>
        </div>
      </div>

      <div class="top-right">
        <div class="pill pill--changed" title="Condition Changed">
          <div class="pill__label">
            <i class="fa-duotone fa-clock"></i>
            Condition Changed
          </div>
          <div class="pill__value">
            {{ item.attentionSetAt || "—" }}
          </div>
        </div>

        <div class="pill" :class="closePillClass" title="Estimated Closing">
          <div class="pill__label">
            <i class="fa-duotone fa-calendar-days"></i>
            Est. Closing
          </div>
          <div class="pill__value">
            {{ item.estimatedClosingDate || "—" }}
          </div>
        </div>
      </div>
    </div>

    <div class="card__main">
      <div class="focus">
        <div class="focus__section">
          <div class="focus__label">
            <i class="fa-duotone fa-file-lines"></i>
            Condition
          </div>
          <div class="focus__title">
            {{ item.title || "—" }}
          </div>
        </div>

        <div class="focus__section">
          <div class="focus__label">
            <i class="fa-duotone fa-circle-exclamation"></i>
            Reason
          </div>
          <div class="focus__reason">
            {{ item.attentionReason || "—" }}
          </div>
        </div>
      </div>
    </div>

    <div class="card__actions">
<div class="actions-left">
  <div class="section-label">
    <i class="fa-duotone fa-sliders-simple"></i>
    Actions
  </div>

  <div class="actions-buttons">
    <button class="action-btn" @click="$emit('open-loan', item.loanId, item.conditionId)">
      <i class="fa-duotone fa-arrow-up-right-from-square"></i>
      Open in Swift
    </button>

    <button class="action-btn" @click="$emit('open-encompass', item.loanId)">
      <i class="fa-duotone fa-arrow-up-right-from-square"></i>
      Open in Encompass
    </button>

    <button class="action-btn" @click="$emit('open-video', item.conditionId)">
      <i class="fa-duotone fa-circle-play"></i>
      Watch UW Video
    </button>
  </div>
</div>


      <div class="actions-right" v-if="members && members.length">
        <div class="team-strip">
          <div v-for="m in members" :key="m.key" class="team-member">
            <div class="team-id">
              <div
                class="team-avatar team-avatar--clickable"
                :class="roleRingClass(m.role)"
                role="button"
                tabindex="0"
                @click="$emit('open-teams', m)"
                @keydown.enter.prevent="$emit('open-teams', m)"
                @keydown.space.prevent="$emit('open-teams', m)"
                :title="m.role || ''"
              >
                <div v-if="isPhotoLoading(m.azid)" class="team-skel"></div>

                <img
                  v-else-if="photoUrl(m.azid)"
                  class="team-img"
                  :src="photoUrl(m.azid)"
                  :alt="m.name"
                  @error="$emit('img-error', m.azid)"
                />

                <div v-else class="team-fallback">
                  {{ initials(m.name) }}
                </div>
              </div>

              <div class="team-meta">
                <div class="team-role">{{ m.role }}</div>
                <div class="team-name">{{ m.name }}</div>
              </div>
              <div class="team-actions">
              <button class="team-action" type="button" @click="$emit('open-teams', m)" title="Chat in Teams">
                <i class="fa-duotone fa-comments"></i>
                <span>Teams</span>
              </button>

              <button class="team-action" type="button" @click="$emit('open-email', m, item)" title="Send Email">
                <i class="fa-duotone fa-envelope"></i>
                <span>Email</span>
              </button>
            </div>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConditionCard",
  props: {
    item: { type: Object, required: true },
    photoUrl: { type: Function, required: true },
    isPhotoLoading: { type: Function, required: true },
    closePillClass: { type: String, default: "pill--neutral" }
  },
  computed: {
    members() {
      const item = this.item || {}
      return [
        { key: "lo", role: "Loan Officer", azid: item.loazid, name: item.loname, teamsUpn: item.loemail },
        { key: "pr", role: "Processor", azid: item.procazid, name: item.procName, teamsUpn: item.procemail },
        { key: "uw", role: "Underwriter", azid: item.uwid, name: item.uwname, teamsUpn: item.uwemail }
      ].filter(x => x.name && x.teamsUpn)
    }
},
  methods: {
    initials(name) {
      const s = String(name || "").trim()
      if (!s) return "—"
      const parts = s.split(/\s+/).filter(Boolean)
      const a = parts[0]?.[0] || ""
      const b = (parts.length > 1 ? parts[parts.length - 1]?.[0] : parts[0]?.[1]) || ""
      const out = (a + b).toUpperCase()
      return out || "—"
    },
    roleRingClass(role) {
      const r = String(role || "").trim().toLowerCase()
      if (!r) return "ring--default"
      if (r.includes("uw") || r.includes("underwriter")) return "ring--uw"
      if (r.includes("processor")) return "ring--processor"
      if (r.includes("clos") || r.includes("closing")) return "ring--closing"
      if (r.includes("loan officer") || r === "lo" || r.includes("originat")) return "ring--lo"
      if (r.includes("assistant") || r.includes("loa")) return "ring--assistant"
      if (r.includes("manager") || r.includes("branch")) return "ring--manager"
      return "ring--default"
    }
  }
}
</script>

<style scoped>
.card {
  border: 1px solid var(--border-ltr);
  border-radius: 16px;
  background: var(--background);
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 6px 18px rgba(0, 0, 0, 0.06);
}

.card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.top-left {
  flex: 1;
  min-width: 0;
}

.id-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--primary-ltst);
  border: 1px solid var(--primary-ltr);
  line-height: 1;
  white-space: nowrap;
}

.chip i {
  color: var(--notification-blue);
}

.chip__label {
  font-size: 12px;
  color: var(--text-secondary-on-background);
  opacity: 0.9;
}

.chip__value {
  font-weight: 800;
  font-size: 12px;
  color: var(--text-primary-on-background);
}

.address-row {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: var(--text-secondary-on-background);
  opacity: 0.95;
}

.address-row i {
  color: var(--notification-blue);
}

.address-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-right {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  min-width: 0;
  max-width: 52%;
}

.pill {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  background: var(--primary-ltst);
  border: 1px solid var(--primary-ltr);
  white-space: nowrap;
  min-width: 0;
  max-width: 520px;
}

.pill__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-secondary-on-background);
  opacity: 0.85;
  flex: 0 0 auto;
}

.pill__label i {
  color: var(--notification-blue);
}

.pill__value {
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-primary-on-background);
}

.pill--changed {
  border-left: 4px solid var(--notification-blue);
  background: linear-gradient(90deg, var(--primary-ltst), var(--background));
}

.pill--green {
  background: #e9f7ef;
  color: var(--success);
  border: 1px solid #d2f0df;
}

.pill--yellow {
  background: #fff6e5;
  color: #9a6b00;
  border: 1px solid #fde9c7;
}

.pill--red {
  background: #fdebec;
  color: var(--kendo-error);
  border: 1px solid #f8d1d3;
}

.pill--neutral {
  background: var(--info);
  color: var(--on-info);
  border: 1px solid var(--border-ltr);
}

.card__main {
  margin-top: 10px;
}

.focus {
  padding: 12px;
  border-radius: 14px;
  background: var(--primary-ltst);
  border-left: 4px solid var(--notification-blue);
}

.focus__section + .focus__section {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.focus__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--text-secondary-on-background);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.focus__label i {
  color: var(--notification-blue);
}

.focus__title {
  margin-top: 6px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.25;
  color: var(--text-primary-on-background);
}

.focus__reason {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.35;
  color: var(--on-background);
  opacity: 0.95;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.card__actions {
  margin-top: 12px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;

  --action-base: rgb(97, 171, 167);
  --action-accent: color-mix(in srgb, var(--action-base) 70%, #000 30%);
  --action-accent-hover: color-mix(in srgb, var(--action-base) 85%, #000 15%);
  --action-surface: color-mix(in srgb, var(--action-base) 6%, transparent);
  --action-surface-hover: color-mix(in srgb, var(--action-base) 10%, transparent);

  background: var(--action-surface);
  border-left: 4px solid var(--action-accent);
  border-radius: 12px;
  padding: 10px 12px;
}

@supports not (background: color-mix(in srgb, #000 50%, #fff 50%)) {
  .card__actions {
    --action-accent: rgb(52, 126, 122);
    --action-accent-hover: rgb(44, 110, 106);
    --action-surface: rgba(97, 171, 167, 0.06);
    --action-surface-hover: rgba(97, 171, 167, 0.1);
  }
}




.actions-left {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px;
  align-items: start;
}

.section-label {
  font-size: 11px;
  color: var(--text-secondary-on-background);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  grid-column: 1 / -1;
  gap: 8px;
}
.actions-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px;
  align-items: start;
}

.section-label i {
  color: var(--action-accent);
}

.action-btn {
  border: 1px solid var(--primary-ltr);
  background: color-mix(in srgb, rgb(97, 171, 167) 25%, var(--background));
  color: var(--text-primary-on-background);
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  gap: 8px;
   width: 100%;
  transition: background-color 120ms ease, border-color 120ms ease, transform 120ms ease;
}

.action-btn i {
  color: var(--action-accent);
}


.action-btn:hover {
  background: color-mix(in srgb, rgb(97, 171, 167) 20%, var(--background));
  border-color: var(--action-accent);
  transform: translateY(-1px);
}

.action-btn:hover i {
  color: var(--action-accent-hover);
}


.actions-right {
  
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  min-width: 0;
  flex: 1 1 auto;
}

.team-strip {
  display: flex;
  gap: 14px;
  align-items: flex-end;
  justify-content: flex-end;
  flex-wrap: nowrap;
  min-width: 0;
}

.team-member {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  row-gap: 6px;
  max-width: 320px;
  padding: 6px 8px;
  border-radius: 12px;
}

.team-id {
  display: grid;
  grid-template-columns: 56px 1fr;
  column-gap: 12px;
  align-items: center;
  min-width: 0;
}

.team-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.team-role {
  font-size: 10px;
  font-weight: 900;
  color: var(--text-secondary-on-background);
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-name {
  font-size: 12px;
  font-weight: 900;
  color: var(--text-primary-on-background);
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-avatar {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  overflow: hidden;
  border: 2px solid var(--notification-blue);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);
  background: color-mix(in srgb, rgb(97, 171, 167) 25%, var(--background));
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
}

.team-avatar--clickable {
  cursor: pointer;
}

.team-avatar--clickable:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
}

.team-avatar--clickable:focus {
  outline: 2px solid var(--notification-blue);
  outline-offset: 2px;
}

.ring--default {
  border-color: var(--notification-blue);
}

.ring--uw {
  border-color: var(--kendo-error);
}

.ring--processor {
  border-color: var(--primary);
}

.ring--closing {
  border-color: var(--success);
}

.ring--lo {
  border-color: var(--kendo-info);
}

.ring--assistant {
  border-color: #9a6b00;
}

.ring--manager {
  border-color: #6b4cff;
}

.team-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.team-skel {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 37%, #f3f4f6 63%);
  background-size: 400% 100%;
  animation: teamShimmer 1.2s ease-in-out infinite;
}

@keyframes teamShimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.team-fallback {
  font-size: 14px;
  font-weight: 900;
  color: var(--text-secondary-on-background);
}

.team-actions {
      padding-top:3px;
  display: flex;
  flex-direction: row;
  gap: 6px;
}

.team-action {
  background: none;
  border: 1px solid transparent;
  padding: 6px 8px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 900;
  color: var(--text-secondary-on-background);
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  opacity: 0.95;
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease, transform 120ms ease;
}

.team-action i {
  color: var(--action-accent);
  font-size: 13px;
  width: 16px;
  display: inline-flex;
  justify-content: center;
}

.team-action span {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.team-action:hover {
  color: var(--action-accent-hover);
  background: var(--action-surface-hover);
  border-color: var(--primary-ltr);
  transform: translateY(-1px);
}

.team-action:hover i {
  color: var(--action-accent-hover);
}

@media (max-width: 1100px) {
  .card__top {
    flex-direction: column;
    align-items: stretch;
  }

  .top-right {
    max-width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .pill {
    max-width: 100%;
  }

  .card__actions {
    flex-direction: column;
    align-items: stretch;
  }

  .actions-right {
    justify-content: flex-start;
  }

  .team-strip {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 700px) {
  .card {
    padding: 10px 10px;
    border-radius: 14px;
  }

  .chip {
    padding: 6px 8px;
  }

  .top-right {
    gap: 8px;
  }

  .pill {
    padding: 8px 9px;
  }

  .pill__label {
    font-size: 10px;
    gap: 6px;
  }

  .pill__value {
    font-size: 12px;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
  }

  .team-member {
    width: 100%;
    max-width: 100%;
    padding: 6px 6px;
  }

  .team-id {
    grid-template-columns: 46px 1fr;
    column-gap: 10px;
  }

  .team-avatar {
    width: 46px;
    height: 46px;
  }

  .team-actions {
    gap: 6px;
    flex-wrap: wrap;
  }

  .team-action {
    padding: 6px 8px;
    border-radius: 10px;
    font-size: 11px;
  }

  .team-action i {
    width: 16px;
  }
}

</style>

